import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const GetPayments = createAsyncThunk("getPayments", async (lastEvaluatedKey) => {
  try {
    console.log("Fetching payments",JSON.stringify(lastEvaluatedKey));
    
    const params = {
      lastEvaluatedKey: JSON.stringify(lastEvaluatedKey),
      limit: "100",
    };
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}payment`,
      {
        params: params,
      }
    );
    console.log("Response Payments---",response);
    const body = JSON.parse(response.data.body);
    console.log("Body---", body);

    if (response.status === 200) {
      return body;
    }

    throw new Error("Failed to retrieve payments");
  } catch (error) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || "Unknown API error");
    }
    throw new Error(error.message || "Network error");
  }
});

export default GetPayments;
